import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    standalone: false
})
export class TimePickerComponent implements OnInit, OnChanges {
    @Input() initialTime: string | null = null; // e.g., "10:30"
    @Input() initialPeriod: 'AM' | 'PM' | null = null;
    @Input() triggerValidation: boolean = false;

    @Output() timeChange = new EventEmitter<{ hour: number; minute: number; period: 'AM' | 'PM' }>();

    timeForm!: FormGroup;

    constructor(private readonly fb: FormBuilder) {}

    ngOnInit(): void {
        this.timeForm = this.fb.group({
            time: [this.initialTime, [Validators.pattern(/^(0?[1-9]|1[0-2]):[0-5]\d$/)]],
            period: [this.initialPeriod]
        });

        this.timeForm.valueChanges.subscribe((value) => {
            if (this.timeForm.valid) {
                if (value !== null && value !== undefined) {
                    const [hourStr, minuteStr] = value?.time?.split(':');
                    this.timeChange.emit({
                        hour: +hourStr,
                        minute: +minuteStr,
                        period: value.period
                    });
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialTime'] !== null && changes['initialTime'] !== undefined) {
            this.timeForm?.controls['time']?.setValue(changes['initialTime']?.currentValue);
        }
        if (changes['initialPeriod'] !== null && changes['initialPeriod'] !== undefined) {
            this.timeForm?.controls['period']?.setValue(changes['initialPeriod']?.currentValue);
        }
        if (changes['triggerValidation'] && changes['triggerValidation'].currentValue === true) {
            this.timeForm.markAllAsTouched();
            this.timeForm.updateValueAndValidity();
        }
    }
    formatTime(event: Event): void {
        const input = (event.target as HTMLInputElement).value.replace(/\D/g, ''); // Remove non-digits
        let formatted = '';

        if (input.length >= 1) {
            formatted += input.substring(0, 2);
        }
        if (input.length >= 3) {
            formatted += ':' + input.substring(2, 4);
        }
        this.timeForm.controls['time'].setValue(formatted, { emitEvent: false });
    }
}
